module.exports = __webpack_public_path__ + "static/fawcett_logo-a449485b713db1914c865c633cac44de.png";